import { Show, TabbedShowLayout } from 'react-admin';
import { styled } from '@mui/material/styles';

export const ShowStyled = styled(Show)({
  paddingBottom: '40px',
});

export const TabbedShowLayoutStyled = styled(TabbedShowLayout)({
  width: '100%',
  paddingBottom: '16px',
});
